import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core'; // MODIFICADO
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { AuthService } from './auth/auth.service';
import { ProyectosListComponent } from './proyectos/proyectos-list.component';
import { ProyectoFormComponent } from './proyectos/proyecto-form/proyecto-form.component';
import { EstimacionComponent } from './estimaciones/estimaciones.component';
import { EstimacionDetailsComponent } from './estimaciones/estimacion-details/estimacion-details.component';
import { ModalEstimationWizardComponent } from './estimaciones/modal-estimation-wizard/modal-estimation-wizard.component';
import { EstimacionService } from './services/estimacion.service';
import { MasterManagementComponent } from './master-management/master-management.component';
import { MasterMenuComponent } from './master-management/components/menu/master-menu.component';
import { MasterFormComponent } from './master-management/components/form/master-form.component';
import { MasterListComponent } from './master-management/components/list/master-list.component';
import { UserRoleManagerComponent } from './user-management/user-role-manager/user-role-manager.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { LayoutComponent } from './layout/layout.component';
import { GlobalModalComponent } from './shared/global-modal/global-modal.component';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { GlobalErrorHandler } from './interceptor/global-error-handler';
import { HasPermissionDirective } from './shared/directives/has-permission.directive';
import { TerminalComponent } from './shared/terminal/terminal.component';
import { MultiSelectComponent } from './shared/multi-select/multi-select.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { TaskExecutionManagerComponent } from './task-execution-manager/task-execution-manager.component';
import { EstimationWarningsPanelComponent } from './components/estimation-warnings-panel/estimation-warnings-panel.component';
import { SharedModule } from './shared/shared.module';
import { TaskSourceBadgeComponent } from './components/task-source-badge/task-source-badge.component';
import { TaskRangeBarComponent } from './components/task-range-bar/task-range-bar.component';
import { EstimationQuickBarComponent } from './components/estimation-quick-bar/estimation-quick-bar.component';
import { ExportPanelComponent } from './export/components/export-panel/export-panel.component';
import { StatusPillAsyncComponent } from './export/components/status-pill-async/status-pill-async.component';
import { SlideOverComponent } from './shared/slide-over/slide-over.component';
import { provideExports } from './export/export.providers';

// NUEVO: Importaciones del Motor E2DB
import { AppConfigService } from './services/app-config.service';
import { SystemConfigComponent } from './system-config/system-config.component';

// Función fábrica para cargar la configuración al iniciar la app
export function initConfig(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ProyectosListComponent,
    ProyectoFormComponent,
    EstimacionComponent,
    EstimacionDetailsComponent,
    ModalEstimationWizardComponent,
    GlobalModalComponent,
    MultiSelectComponent,
    MasterManagementComponent,
    MasterMenuComponent,
    MasterFormComponent,
    MasterListComponent,
    UserRoleManagerComponent,
    LayoutComponent,
    HasPermissionDirective,
    TerminalComponent,
    TaskExecutionManagerComponent,
    EstimationWarningsPanelComponent,
    TaskSourceBadgeComponent,
    TaskRangeBarComponent,
    EstimationQuickBarComponent,
    UserManagementComponent,
    DashboardComponent,
    ProfileComponent,
    SystemConfigComponent // NUEVO
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatDialogModule,
    HttpClientModule,
    CommonModule,
    DragDropModule,
    MatSnackBarModule,
    SharedModule,
    ExportPanelComponent,
    StatusPillAsyncComponent,
    SlideOverComponent
  ],
  exports: [
    EstimacionComponent,
    MultiSelectComponent
  ],
  providers: [AuthService, EstimacionService, provideAnimationsAsync(),
    // Exporters (Punto 3+) — registro multi-provider único, ver export.providers.ts
    ...provideExports(),
    // NUEVO: Provider del Inicializador
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [AppConfigService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }